/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Hawking_TextInputs */

const en_home_quotes_hawking_text = /** @type {(inputs: Home_Quotes_Hawking_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The development of full artificial intelligence could spell the end of the human race.`)
};

/**
* | output |
* | --- |
* | "The development of full artificial intelligence could spell the end of the human race." |
*
* @param {Home_Quotes_Hawking_TextInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_hawking_text = /** @type {((inputs?: Home_Quotes_Hawking_TextInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Hawking_TextInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_hawking_text(inputs)
});